
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import DateUtils from '@/common/js/DateUtils'

    class RegisteredRequest  {
        UserName: string;
        Password: string;
        ReplacePassWord: string;
        Phone: string;
        WeChat: string;
    }


    @Component
    export default class RegisteredSetting extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        registeredRequest: RegisteredRequest = new RegisteredRequest();

        async save() {
            (this.$refs.baseSettingForm as any).validate(async (valid: boolean) => {
                if (valid) {
                    if (this.registeredRequest.Password != this.registeredRequest.ReplacePassWord) {
                       this.$Message.error('密码与确认密码不一致。');
                       return;
                    }
                    this.$Message.loading({
                        content: this.L('开始注册'),
                        duration: 0
                    })
                    await this.$store.dispatch({
                        type: 'account/register',
                        data: this.registeredRequest
                    })
                    this.$Message.destroy();
                    this.$Modal.success({title:"注册成功",content:"请直接登录！"});
                    this.$emit('input', false);
                }
            });
        }
        cancel() {
            (this.$refs.baseSettingForm as any).resetFields();
            this.$emit('input', false);
        }
        visibleChange(value: boolean) {
            if(!value){
                this.$emit('input',value);
            }
        }
        rules = {
           UserName: [
                { required: true, message: this.L('账号不能为空'), trigger: 'blur' }
            ],
            Password: [
                { required: true, message: this.L('密码不能为空'), trigger: 'blur' }
            ],
            ReplacePassWord: [
                { required: true, message: this.L('确认密码不能为空'), trigger: 'blur' }
            ],
            Phone: [
                { required: true, message: this.L('手机号码不能为空'), trigger: 'blur' },
                { min:11,max:11, message: this.L('请输入正确手机号码'), trigger: 'blur' }
            ],
            WeChat: [
                { required: true, message: this.L('微信号码不能为空'), trigger: 'blur' }
            ]
        }
    }
